(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal, .mt-tabla');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { if (!el.classList.contains('mt-visible')) observer.observe(el); });
  }

  /* CTA magnético (#88) */
  function initMagnetico(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('[data-mt-magnetico]').forEach(function (btn) {
      if (btn.dataset.mtInit) return; btn.dataset.mtInit = '1';
      var zona = btn.parentElement;
      zona.addEventListener('mousemove', function (ev) {
        var r = btn.getBoundingClientRect();
        var dx = ev.clientX - (r.left + r.width / 2), dy = ev.clientY - (r.top + r.height / 2);
        if (Math.abs(dx) < r.width && Math.abs(dy) < r.height * 2) {
          btn.style.transform = 'translate(' + Math.max(-6, Math.min(6, dx * 0.08)) + 'px,' + Math.max(-6, Math.min(6, dy * 0.12)) + 'px)';
        }
      });
      zona.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* Hotspots (#17) */
  function initHotspots(root) {
    (root || document).querySelectorAll('[data-mt-hotspots]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var puntos = sec.querySelectorAll('.mt-hs__punto'), items = sec.querySelectorAll('.mt-hs__item');
      function activa(i) {
        puntos.forEach(function (p, k) { p.classList.toggle('mt-activo', k === i); });
        items.forEach(function (it, k) { it.classList.toggle('mt-activo', k === i); });
      }
      puntos.forEach(function (p, i) { p.addEventListener('click', function () { activa(i); }); p.addEventListener('mouseenter', function () { activa(i); }); });
      items.forEach(function (it, i) { it.addEventListener('click', function () { activa(i); }); it.addEventListener('mouseenter', function () { activa(i); }); });
      activa(0);
    });
  }

  /* Calculadora (#65) */
  function initCalculadora(root) {
    (root || document).querySelectorAll('[data-mt-calc]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var cfg = JSON.parse(sec.dataset.mtCalc);
      var nPesas = sec.querySelector('[name=pesas]'), precio = sec.querySelector('[name=precio]');
      var outN = sec.querySelector('[data-out=pesas]'), outP = sec.querySelector('[data-out=precio]');
      var rAhorro = sec.querySelector('[data-res=ahorro]'), rCoste = sec.querySelector('[data-res=coste]'), rEspacio = sec.querySelector('[data-res=espacio]');
      var actual = 0, anim = null;
      function fmt(v) { return Math.round(v).toLocaleString('es-ES') + ' ' + cfg.moneda; }
      function pinta(el) { var p = (el.value - el.min) / (el.max - el.min) * 100; el.style.setProperty('--mt-p', p + '%'); }
      function cuenta(destino) {
        if (anim) cancelAnimationFrame(anim);
        var desde = actual, t0 = null;
        function paso(t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / 600), v = desde + (destino - desde) * (1 - Math.pow(1 - k, 3));
          rAhorro.textContent = fmt(v); actual = v;
          if (k < 1) anim = requestAnimationFrame(paso);
        }
        if (reduce) { actual = destino; rAhorro.textContent = fmt(destino); } else anim = requestAnimationFrame(paso);
      }
      function calcula() {
        var n = +nPesas.value, p = +precio.value;
        outN.textContent = n; outP.textContent = p + ' ' + cfg.moneda;
        pinta(nPesas); pinta(precio);
        var coste = n * p;
        rCoste.textContent = fmt(coste);
        rEspacio.textContent = (n * cfg.espacio).toLocaleString('es-ES') + ' ' + cfg.unidad;
        cuenta(Math.max(0, coste - cfg.producto));
      }
      nPesas.addEventListener('input', calcula); precio.addEventListener('input', calcula);
      calcula();
    });
  }

  /* FAQ (#80) */
  function initFaq(root) {
    (root || document).querySelectorAll('.mt-faq__q').forEach(function (q) {
      if (q.dataset.mtInit) return; q.dataset.mtInit = '1';
      q.addEventListener('click', function () {
        var item = q.closest('.mt-faq__item'), abierto = item.classList.toggle('mt-abierto');
        q.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  /* Página de producto: galería, variantes y cantidad */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-mt-producto]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var principal = sec.querySelector('.mt-pp__principal img');
      sec.querySelectorAll('.mt-pp__mini').forEach(function (m) {
        m.addEventListener('click', function () {
          sec.querySelectorAll('.mt-pp__mini').forEach(function (x) { x.classList.remove('mt-activo'); });
          m.classList.add('mt-activo');
          principal.src = m.dataset.grande; principal.srcset = '';
        });
      });
      var cant = sec.querySelector('.mt-pp__cantidad input');
      sec.querySelectorAll('[data-mt-cant]').forEach(function (b) {
        b.addEventListener('click', function () { cant.value = Math.max(1, (+cant.value || 1) + (+b.dataset.mtCant)); });
      });
      var datos = sec.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent), cfg = JSON.parse(sec.dataset.mtProducto);
      var idInput = sec.querySelector('input[name=id]'), boton = sec.querySelector('.mt-pp__comprar .mt-btn');
      var precio = sec.querySelector('.mt-pp__precio-actual'), tachado = sec.querySelector('.mt-pp__precio-tachado');
      sec.querySelectorAll('.mt-pp__valores input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = Array.prototype.map.call(sec.querySelectorAll('.mt-pp__opcion'), function (f) {
            var c = f.querySelector('input:checked'); return c ? c.value : null;
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) { boton.disabled = true; boton.querySelector('span').textContent = cfg.noDisponible; return; }
          idInput.value = v.id;
          precio.textContent = v.price_fmt;
          if (tachado) { tachado.textContent = v.compare_fmt || ''; tachado.style.display = v.compare_fmt ? '' : 'none'; }
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? cfg.comprar : cfg.agotado;
          if (v.image && principal) { principal.src = v.image; principal.srcset = ''; }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
        });
      });
    });
  }

  /* Pestañas de filtro del catálogo */
  function initPestanas(root) {
    (root || document).querySelectorAll('[data-mt-tabs]').forEach(function (barra) {
      if (barra.dataset.mtInit) return; barra.dataset.mtInit = '1';
      var cont = barra.parentElement;
      barra.addEventListener('click', function (ev) {
        var b = ev.target.closest('.mt-tab'); if (!b) return;
        barra.querySelectorAll('.mt-tab').forEach(function (x) { x.classList.toggle('is-activa', x === b); x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        var et = b.dataset.etiqueta;
        cont.querySelectorAll('.mt-prod').forEach(function (p) {
          var ok = !et || p.dataset.etiquetas.indexOf(' ' + et + ' ') > -1;
          p.classList.toggle('is-oculto', !ok);
          if (ok) p.classList.add('mt-visible');
        });
      });
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveal(root); initMagnetico(root); initHotspots(root); initCalculadora(root); initFaq(root); initProducto(root); initPestanas(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
